import { render, staticRenderFns } from "./companyMerchantNetUpdate.vue?vue&type=template&id=1ea54612&scoped=true&"
import script from "./companyMerchantNetUpdate.vue?vue&type=script&lang=js&"
export * from "./companyMerchantNetUpdate.vue?vue&type=script&lang=js&"
import style0 from "./companyMerchantNetUpdate.vue?vue&type=style&index=0&id=1ea54612&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea54612",
  null
  
)

export default component.exports